import { Injectable, Inject } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from "@angular/common/http";
import { DOCUMENT } from "@angular/common";

import { Observable } from "rxjs";
import { NgxSpinnerService } from "ngx-spinner";
import { SharedService } from "../modules/shared/services/shared.service";

import { CookieService } from "ngx-cookie";
import { tap } from 'rxjs/operators';
import { CclMessageService } from "certain-common-library";

/** Pass untouched request through to the next request handler. */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(
        @Inject(DOCUMENT) private document,
        private spinner: NgxSpinnerService,
        public sharedService: SharedService,
        private cookieService: CookieService,
        private messageService: CclMessageService
    ) {}
    requestCount: number = 0;
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this.sharedService.isUpload) {
            if (this.sharedService.setup != null) {
                req = req.clone({ params: req.params.set("catalogUUID", this.sharedService.setup.uuid) });
                req = req.clone({ params: req.params.set("speakerCatalogId", this.sharedService.setup.id) });
            }
            if (!req.headers.has("Content-Type")) {
                req = req.clone({ headers: req.headers.set("Content-Type", "application/json") });
            }
            if (!req.headers.has("Accept")) {
                req = req.clone({ headers: req.headers.set("Accept", "application/json") });
            }
        } else {
            this.sharedService.isUpload = false;
            req = req.clone({ params: req.params.set("catalogUUID", this.sharedService.catalogUUID) });
        }
        if (!req.headers.has("X-XSRF-TOKEN")) {
            req = req.clone({ headers: req.headers.set("X-XSRF-TOKEN", this.cookieService.get("XSRF-TOKEN")) });
        }

        this.requestCount++;
        if (!this.sharedService.generalListLoading) {
            if (this.requestCount == 1 && this.sharedService.showLoader) {
                this.spinner.show();
            }
        } else {
            this.spinner.hide();
        }
        return next.handle(req).pipe(tap(
            (response) => {
                if (response instanceof HttpResponse) {
                    try {
                        if (req.method == 'POST' && req.url.match('\/svcs\/session_catalog\/setup\/([0-9]+)')) {
                            this.sharedService.setup.dateModified = response["body"]["sessionCatalogSetupDTO"]["dateModified"];
                            this.messageService.sendMessage("update-publish-button");
                        }
                        if (req.method == 'POST' && req.url.match('\/svcs\/session_catalog\/setup\/config\/([0-9]+)')) {
                            this.sharedService.setup.dateModified = response["body"]["sessionCatalogSetupConfigDTO"]["dateModified"];
                            this.messageService.sendMessage("update-publish-button");
                        }
                    } catch (error) {
                    }
                    this.requestCount--;
                    if (this.requestCount == 0) {
                        this.spinner.hide();
                    }
                }
            },
            (error) => {
                this.requestCount--;
                if (this.requestCount == 0) {
                    this.spinner.hide();
                }
                if (error.status === 401 || error.status === 403) {
                    let url = document.location.protocol + "//" + document.location.hostname;
                    window.location.href = url;
                }
            }
        ));
    }
}
